<template>
  <div id="questions" class="p-4">
    <div class="card w-100">
      <div class="card-header py-3">
        <div class="pt-2 font-bold text-uppercase">PTI Dispatch Library</div>
      </div>
      <div class="card-body p-0">
<!--        <button class="btn btn-create my-2 ml-4" @click="onShowCreateModal()">+ Add Question</button>-->
        <ul class="list-group list-group-flush" v-for="section of getSections" :key="section.id">
          <li class="list-group-item list-group-item-action font-bold d-flex justify-content-between w-100 align-center mobile-column">
            <span>{{ section.name }}</span>
            <button class="btn btn-create question-create my-2 ml-4" @click="onShowCreateModal(section.id)">+ Add <span class="mobile-hidden">Question</span></button>
          </li>
          <v-draggable v-model="section.questions"
                       draggable=".list-group-item"
                       handle=".handle"
                       tag="tbody"
                       class="table__tbody"
                       @sort="onSortSections($event, section.questions)">
            <li class="list-group-item list-group-item-action d-flex justify-content-between align-items-center"
                v-for="question of section.questions"
                :key="question.id">
              <span>
                <span class="handle cursor-pointer pr-2">
                  <img src="../assets/img/sort-icon.png">
                </span>
                {{ question.text }}
              </span>
              <div class="d-flex align-center">
                <span class="cursor-pointer" @click="onShowEditModal(question)">
                  <img src="../assets/img/edit-icon.png">
                </span>
                <span @click="onShowDeleteModal(question.id)" aria-hidden="true" class="question-remove d-flex ml-2">&times;</span>
              </div>
            </li>
          </v-draggable>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
  import {mapActions, mapGetters} from 'vuex'

  export default {
    name: 'Questions',
    computed: {
      ...mapGetters([
        'getSections',
      ])
    },
    mounted() {
      this.querySections()
    },
    methods: {
      ...mapActions([
        'querySections',
        'sortQuestions',
        'setSectionId',
        'showModal',
        'setQuestionId'
      ]),
      onShowCreateModal(sectionId) {
        this.setSectionId(sectionId)
        this.showModal({modal: 'ModalQuestion', data: {}})
      },
      onShowEditModal(question) {
        this.showModal({modal: 'ModalQuestion', data: question})
      },
      onShowDeleteModal(questionId){
        this.setQuestionId(questionId)
        this.showModal({modal: 'ModalConfirmRemove'})
      },
      onSortSections(event, questions) {
        this.sortQuestions(questions)
      },
    }
  }
</script>

<style scoped>
.align-center{
  align-items: center;
}
.mobile-hidden{
  display:inline;
}
.question-remove{
  font-size:32px;
  color:#666;
  line-height: 1px;
  cursor: pointer;
  transition: color 0.3s ease-in-out;
}
.question-remove:hover{
  color:#cd0e2d;
}

@media(max-width:767px){
  .mobile-hidden{
      display:none;
  }
  .question-create{
    width:auto;
    min-width:75px;
  }
}
@media(max-width:400px){
  .mobile-column{
    flex-direction: column;
  }
  .question-create{
    width:100%;
    margin-left:0 !important
  }
}

</style>
